export default __webpack_public_path__ + "static/media/airtel.fb217675.svg";